import { Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import { authRouter, publicRouter } from "./Routes/router";
import { ProtectedRoute, GetLocalStorage } from "./HigherOrderComponent";
import Master from "./Layouts/Master";
import { MarketWatchProvider } from "./Context/MarketWatchContext";

const App = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {authRouter.map((route, index) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute>
                <MarketWatchProvider>
                  <Master />
                </MarketWatchProvider>
              </ProtectedRoute>
            }
          >
            <Route
              key={index}
              path={route.path}
              element={<route.component />}
            />
          </Route>
        ))}

        {publicRouter.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <GetLocalStorage>
                <route.component />
              </GetLocalStorage>
            }
          />
        ))}

        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Suspense>
  );
};

export default App;
